import React, { Component } from 'react';
import {
    Grid,
    Card,
    CardTitle,
    DataTable,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
    Autocomplete,
    Button,
    CardText,
    DatePicker,
    Switch
} from 'react-md';
import Api from '../../common/api';

import { formatCurrency, formatQuantidade } from '../../common/formaters'
import Message from '../../components/message';
import Breadcrumb from '../../components/Breadcrumb';
import { openSnackbar } from '../../components/message';
import { css } from '../../styles/print.css';

const TODAY = new Date();

export default class Relatorio extends Component {

    constructor(props) {
        super(props);

        this.state = {
            filterType: Autocomplete.caseInsensitiveFilter,
            comprador: {
                id: "",
                nome: "",
                saldo_devedor: "",
                telefones: [],
            },
            nome_comprador: "",
            sugestoes: [],
            pedidos: [],
            pagamentos: [],
            total: "",
            lucro: "",
            saldo_devedor: [],
            data_inicial: "",
            data_final: "",
            custos_lucro: false
        };
    }

    componentDidMount() {
        this.setFilterInitialDate();
    }

    render() {
        const { custos_lucro, pedidos, total, lucro, sugestoes, 
            pagamentos, nome_comprador, saldo_devedor } = this.state;
        return (
            <Grid>
                <Breadcrumb title="Relatório" url="/relatorio"/>
                <Card className="md-cell md-cell--12 tw-card">
                    <CardTitle title="Filtro"/>
                    <CardText>
                        <form onSubmit={this.getRelatorio}>
                            <div className="md-grid">
                                <DatePicker id="data_inicial" label="Selecione a data inicial"
                                    autoOk className="md-cell md-cell--bottom" defaultValue={new Date(TODAY.getFullYear(), TODAY.getMonth(), 1)} 
                                    onChange={this.handleChangeData('data_inicial')} />
                                
                                <DatePicker id="data_final" label="Selecione a data final"
                                    autoOk className="md-cell md-cell--bottom" defaultValue={TODAY} 
                                    onChange={this.handleChangeData('data_final')} />
                                
                                <Autocomplete id="nome" label="Cliente" data={sugestoes} filter={null} onChange={this.onSearchAutocomplete} 
                                    clearOnAutocomplete simplifiedMenu={false} onAutocomplete={this.handleAutocomplete} dataLabel={"nome"}
                                    sameWidth={false} value={nome_comprador} className="md-cell md-cell--bottom" dataValue="id"/>
                            </div>
                            <div className="buttons__group">
                                    <div className="left-group">
                                        <Switch id="custos-lucro-visible" type="switch" onChange={this.handleChangeColunas}
                                            label="Exibir Custos | Lucro" name="custos-lucro-visible" />
                                    </div>
                                    <div style={{margin:"0 30% 0 0"}} className="right-group">
                                        <Button type="submit" raised primary >Consultar</Button>
                                    </div>
                            </div>
                        </form>
                    </CardText>
                </Card>
                { pedidos.length ? 
                    <Card id="relatorio-pedidos" tableCard className="md-cell md-cell--12 tw-card">
                        <div className="buttons__group">
                            <div className="left-group"></div>
                            <div className="right-group">
                                <Button type="button" raised iconChildren="print" className="btn btn-primary button" onClick={this.print}>
                                    Imprimir
                                </Button>
                            </div>
                        </div>
                        <CardTitle title="Pedidos"/>
                        { pedidos.map((pedido, index) => (
                            <div key={index}>
                                <CardText>
                                    <h4><b>{pedido.nome}</b></h4>
                                    <p><b>{pedido.criado}</b></p>
                                </CardText>
                                <DataTable baseId="relatorio-table" fullWidth={true} className="tw-table" plain={true} >
                                    <TableHeader>
                                        <TableRow>
                                            <TableColumn style={{padding:"0"}}>Quantidade</TableColumn>
                                            <TableColumn>Id</TableColumn>
                                            <TableColumn>Item</TableColumn>
                                            { custos_lucro && <TableColumn>Custo</TableColumn> }
                                            <TableColumn>Valor Un.</TableColumn>
                                            <TableColumn>Total</TableColumn>
                                            { custos_lucro && <TableColumn>Lucro</TableColumn> }
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {pedido.itens.map((item, index) => (
                                            <TableRow key={index} style={index % 2 === 0 ? {background: "#eee", border: "3px solid ", borderColor: "gray"} : {background: "white", border: "3px solid", borderColor: "gray"}}>
                                                <TableColumn className="td-background" style={{width:"9%"}}>
                                                    <div className="div-background-value">{formatQuantidade(item.quantidade)}</div>
                                                </TableColumn>
                                                <TableColumn className="td-background" style={{width:"6%"}}>
                                                    <div className="div-background-value">{item.id_item}</div>
                                                    </TableColumn>
                                                <TableColumn className="td-background" style={{width:"39%"}}>
                                                    <div className="div-background-name">{item.nome}</div>
                                                    </TableColumn>
                                                { custos_lucro && <TableColumn className="td-background" style={{width:"9%", fontSize:"small"}}>
                                                    <div className="div-background-value">{formatCurrency(item.custo_unitario)}</div>
                                                    </TableColumn> }
                                                <TableColumn className="td-background" style={{width:"9%", fontSize:"small"}}>
                                                    <div className="div-background-value">{formatCurrency(item.valor_unitario)}</div>
                                                    </TableColumn>
                                                <TableColumn className="td-background" style={{width:"14%", fontSize:"small"}}>
                                                    <div className="div-background-value">{formatCurrency(item.total)}</div>
                                                    </TableColumn>
                                                { custos_lucro && <TableColumn style={{width:"14%", fontSize:"small"}} className="td-background">
                                                    <div className="div-background-value">{formatCurrency(item.lucro)}</div>
                                                    </TableColumn> }
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </DataTable>
                                {pedido.observacao ? 
                                    <CardText>
                                        <p><b>Observação:</b></p>
                                        <p>{pedido.observacao}</p>
                                    </CardText>
                                : null}

                                <div className="md-cell--left md-cell--12 md-text-right">
                                    <h4>Total pedido: <b>{formatCurrency(pedido.total)}</b></h4>
                                    { custos_lucro && <h4>Total lucro: <b>{formatCurrency(pedido.lucro)}</b></h4> }
                                </div>
                            </div>
                        ))}
                        {pagamentos.length ? 
                            <div>
                                <CardText>
                                    <h4><b>PAGAMENTOS</b></h4>
                                </CardText>
                                <DataTable baseId="pagamentos-table" fullWidth={true} className="tw-table" plain={true} >
                                    <TableHeader>
                                        <TableRow>
                                            <TableColumn>Data</TableColumn>
                                            <TableColumn>Valor</TableColumn>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {pagamentos.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableColumn>{item.data}</TableColumn>
                                                <TableColumn>{formatCurrency(item.valor)}</TableColumn>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </DataTable>
                            </div>
                        : null}
                        <div className="md-cell--left md-cell--12 md-text-right">
                            <h4>Total geral: <b>{formatCurrency(total)}</b></h4>
                            { saldo_devedor && <h4>Saldo devedor: <b>{formatCurrency(saldo_devedor) || 'R$ 0,000'}</b></h4> }
                            { custos_lucro && <h4>Lucro geral: <b>{formatCurrency(lucro)}</b></h4> }
                        </div>
                    </Card>
                : null}
                <Message />
            </Grid>
        );
    }
    handleChangeColunas = value => {
        this.setState({ custos_lucro: value });
    }

    handleChangeData = name => value => {
        this.setState({ [name]: value });
    }

    getRelatorio = event => {
        event.preventDefault();
        Api.getRelatorio(this.state.data_inicial, this.state.data_final, this.state.comprador.id)
        .then(response => response.json())
        .then(response => this.setState({
            pedidos: response.pedidos || [], 
            pagamentos: response.pagamentos || [],
            total: response.total || "", 
            lucro: response.lucro || "",
            saldo_devedor: response.saldo_devedor || ""
        }))
        .catch(error => openSnackbar({ message: error }));
    }

    onSearchAutocomplete = value => {
        this.setState({nome_comprador: value});
        if(value.length === 0){
            let comprador = {
                id: "",
                nome: "",
                saldo_devedor: "",
                telefones: [],
            }
            this.setState({comprador});
        }
        if(value.length < 3) return;
        Api.getAllCompradores(value)
        .then(response => response.json())
        .then(sugestoes => this.setState({sugestoes}))
        .catch(error => openSnackbar({ message: error }));
    }

    handleAutocomplete = (value, index, matches) => {
        let comprador = matches[index];
        let nome_comprador = comprador.nome;
        this.setState({ comprador, nome_comprador });
    };

    print = () => {
        Api.print(css, 'relatorio-pedidos');
        this.props.history.push('/clientes');
        return true;
    }

    setFilterInitialDate = () => {
        let data_inicial = new Date(TODAY.getFullYear(), TODAY.getMonth(), 1);
        let data_final = TODAY;
        this.setState({
            data_inicial: data_inicial.toLocaleDateString(), 
            data_final: data_final.toLocaleDateString()
        });
    }
}



// WEBPACK FOOTER //
// ./src/views/relatorio/Relatorio.js